import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Consistent bottom-right "See more info" CTA used across Reports & Intelligence.
 *
 * Two flavours:
 *  - <SeeMoreLink to="/back-office/…" />                — navigates to a report route
 *  - <SeeMoreLink onClick={…} />                        — opens a drill sheet
 *
 * Optionally pass `label` to override the default text (e.g. "Open report").
 */
// `what` names what the link is more of ("More on labour %"): fourteen links all reading
// "See more info" told a screen reader, and anyone scanning, nothing (Chris's review L7).
const SeeMoreLink = ({ to, onClick, what, label = what ? `More on ${String(what).toLowerCase()}` : 'More', testId }) => {
  const baseCls =
    'text-[12.5px] font-semibold text-verlo hover:text-verlo-hover inline-flex items-center gap-0.5 transition-colors';

  if (to) {
    return (
      <Link to={to} className={baseCls} data-testid={testId}>
        {label}
        <ChevronRight size={12} />
      </Link>
    );
  }
  return (
    <button type="button" onClick={onClick} className={baseCls} data-testid={testId}>
      {label}
      <ChevronRight size={12} />
    </button>
  );
};

export default SeeMoreLink;
